import type { FormikHelpers } from "formik";
import { FormikInputWithLabel } from "newui/components/ui/InputWithLabel";
import React from "react";

interface UsernamePasswordProps {
	emailDataTestid: string;
	isSignUp?: boolean;
	passwordConfirmationDataTestid?: string;
	passwordDataTestid?: string;
	setFieldValue?: FormikHelpers<any>["setFieldValue"];
}

/**
 * UsernamePassword component renders email and password fields.
 * Fully accessible with labels and aria attributes.
 */
const UsernamePassword: React.FC<UsernamePasswordProps> = ({
	setFieldValue,
	emailDataTestid,
	passwordDataTestid,
	passwordConfirmationDataTestid,
	isSignUp = false,
}) => {
	return (
		<>
			<FormikInputWithLabel
				id="email"
				label="Email"
				name="email"
				type="email"
				placeholder="Enter your email"
				className="col xl-12"
				data-testid={emailDataTestid}
				setFieldValue={setFieldValue}
				autoComplete="username"
				aria-required="true"
				maxLength={190}
			/>

			<FormikInputWithLabel
				id="password"
				label="Password"
				name="password"
				type="password"
				placeholder="Enter your password"
				className="col xl-12"
				data-testid={passwordDataTestid}
				setFieldValue={setFieldValue}
				icon
				autoComplete={isSignUp ? "new-password" : "current-password"}
				aria-required="true"
			/>

			{isSignUp && <FormikInputWithLabel
				id="passwordConfirmation"
				label="Confirm Password"
				name="password_confirmation"
				type="password"
				placeholder="Confirm your password"
				className="col xl-12"
				data-testid={passwordDataTestid}
				setFieldValue={setFieldValue}
				icon
				autoComplete={"new-password"}
				aria-required="true"
			/>}
		</>
	);
};

export default UsernamePassword;
